import { useContext, useState } from 'react';
import Titel from "../DetailPaint/titel";
import { AxiosPublic } from '../../config/axios';
import { Authorization } from '../../providers/AuthContextProvider';
import { CartContext } from '../../providers/CartContextProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Password = ({ user, setVerifyCom }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState();

    const { getTokens } = useContext(Authorization)
    const { state, dispatch } = useContext(CartContext)


    const push = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null)
        setLoading(true)
        await AxiosPublic.post("login", { user, password })
            .then(async res => {
                const { token, ...prev } = res.data.data
                getTokens(token)
                await axios.post('shopping-cart/store', state,
                    { headers: { Authorization: `${token.token_type} ${token.access_token}` } })
                    .then(res => dispatch({ type: "UPDATE_CART", payload: res.data.data }))
                    .catch(err => alert(err.response?.data.message))
                await push(`/${prev.is_admin ? 'admin' : 'profile'}/information`)
            })
            .catch(err => setError(err.response?.data.message || 'رمز عبور اشتباه است'))
            .finally(() => setLoading())
    };

    return (
        <div className="max-w-md w-full flex flex-col">
            <div className='bg-white rounded-b-lg p-8'>
                <Titel title='ورود با رمز عبور' />
                <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
                    <div className='flex flex-col gap-4'>
                        <label htmlFor="password" className="block font-medium text-gray-700">
                            رمز عبور
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#C3003F] focus:border-[#C3003F] sm:text-sm"
                            required
                        />
                    </div>
                    {error && <p className="text-sm text-red-600">{error}</p>}
                    <button disabled={loading} type="submit" className={`text-white centerOfParent h-12 w-full bg-gradient-to-r from-[#C3003F]  to-[#5D001E] hover:bg-gradient-to-br focus:outline-none font-medium rounded-lg text-lg px-5 py-2.5 text-center`}>
                        {loading ?
                            <div role="status">
                                <svg className='className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-white' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                            : 'ورود'}
                    </button>
                    <p onClick={() => setVerifyCom(1)} className='text-sm text-blue-500 cursor-pointer'>رمز عبور خود را فراموش کرده ام!</p>
                </form>
            </div>
        </div>
    );
};

export default Password;
